import { render } from "./StatusBar.vue?vue&type=template&id=06ec7019&scoped=true&bindings={}"
import script from "./StatusBar.vue?vue&type=script&lang=ts"
export * from "./StatusBar.vue?vue&type=script&lang=ts"

import "./StatusBar.vue?vue&type=style&index=0&id=06ec7019&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-06ec7019"

export default script